import React, { useEffect } from "react";
import { Helmet } from "react-helmet";

export const AdComponent = () => {
  useEffect(() => {}, []);

  return <div></div>;
};
